import moment from "moment";
import { ClassAttributes, HTMLAttributes, memo } from "react";
import { PersonCircle } from "react-bootstrap-icons";

const RowRenderer = memo((props: {
  className: any;
  columns: any;
  index?: number;
  isScrolling?: boolean;
  key?: string;
  onRowClick?: (params: any) => void;
  rowData: any;
  style: any;
}) => {
  const { columns, className, rowData, style, onRowClick } = props;
  const { id } = rowData;

  const name =
    (rowData?.firstName
      ? rowData.firstName.charAt(0).toUpperCase() +
      rowData.firstName.substring(1)
      : "") +
    " " +
    (rowData?.lastName
      ? rowData.lastName.charAt(0).toUpperCase() +
      rowData?.lastName.substring(1)
      : "");

      console.log("row Data....", name);

  const isClickable = rowData.status !== null && rowData.status !== undefined;

  console.log("address data", rowData?.address, rowData?.city , rowData?.zip, rowData?.region);

  const address = rowData?.address
    ? `${rowData.address.address || ""}, ${rowData.address.city || ""}, ${rowData.address.zip || ""
    },[${rowData.address.region}]`
    : "-";

    console.log("isClickable", columns);
    console.log("isClickable", rowData);

  return (
    <div
      className={`${className} ${isClickable ? "" : "disabled-row"}`}
      style={style}
      onClick={isClickable && onRowClick ? () => onRowClick(id) : undefined}
      key={`customer-row-${id}`}
    >
      {/* {columns.map(
        (col: {
          props: JSX.IntrinsicAttributes &
          React.ClassAttributes<HTMLDivElement> &
          React.HTMLAttributes<HTMLDivElement>;
        }) => {
          const keyName: any = col.props["aria-describedby"];

          let value = rowData[keyName];

          if (typeof value === "object" && value !== null) {
            value = JSON.stringify(value);
          }

          if (keyName === "Name") {
            return (
              <div
                {...col.props}
                title={name}
                key={`${col.props["aria-describedby"]}-cell-${id}`}
              >
                <PersonCircle className="me-2" size={20} />
                <span>{name.trim()?.length ? name : "-"}</span>
              </div>
            );
          }

          console.log("keyName", keyName, value);

          if (keyName === "address") {
            return (
              <div {...col.props} title={address} key={`${keyName}-cell-${id}`}>
                {address}
              </div>
            );
          }

          return (
            <div
              {...col.props}
              title={value || "-"}
              key={`${col.props["aria-describedby"]}-cell-${id}`}
            >
              {value && value.length ? value : "-"}
            </div>
          );
        }
      )} */}

      {columns.map(
              (col: {
                props: JSX.IntrinsicAttributes &
                  ClassAttributes<HTMLDivElement> &
                  HTMLAttributes<HTMLDivElement>;
              }) => {
                const keyName: any = col.props['aria-describedby'];
                console.log('keyName',  keyName);
                // const keyName: any = col.props["dataKey"];
                let value = rowData[keyName];
                // let value = rowData[dataKey];
      
                if (typeof value === 'object' && value !== null) {
                  value = JSON.stringify(value);
                }
      
                if (keyName === 'Name' || keyName === 'name') {
                // if (keyName === 'firstName') {////
                  const fullName = rowData.name?.trim() || '-';
                  console.log('name value', value,fullName,keyName);
                  return (
                    <div
                      {...col.props}
                      title={fullName}
                      key={`${keyName}-cell-${id}`}
                    >
                      <PersonCircle className="me-2" size={20} />
                      <span>{name}</span>
                    </div>
                  );
                }
      
                if (keyName === 'createdAt') {
                  value = rowData?.createdAt
                    ? moment(rowData.createdAt, 'YYYY-MM-DD HH:mm:ss').format(
                        'DD/MM/YYYY, hh:mm A'
                      )
                    : 'N/A';
                }
      
                if (keyName === 'address') {
                  return (
                    <div {...col.props} title={address} key={`${keyName}-cell-${id}`}>
                      {address}
                    </div>
                  );
                }
      
                if (!keyName || !rowData[keyName] === null) {
                  return (
                    <div
                      {...col.props}
                      key={`${col.props['aria-describedby']}-cell-${id}`}
                    >
                      {' '}
                      -{' '}
                    </div>
                  );
                }
                return (
                  <div
                    {...col.props}
                    title={value || '-'}
                    key={`${col.props['aria-describedby']}-cell-${id}`}
                  >
                    {value}
                  </div>
                );
              }
            )}
    </div>
  );
});

export default RowRenderer;